<ng-template #itemTemplate>
	@if (mode() === 'default') {
	<div libFlexRow [libFlexRowGap]="'16px'" [libFlexRowAlign]="'center'">
		@if (avatarLocation() === 'start' && avatar(); as avatar) {
		<div libFlexColumn>
			<lib-image
				[imageSize]="'50px'"
				[maxHeight]="30"
				[maxWidth]="30"
				[image]="avatar"
				[alt]="'Avatar image'"
			></lib-image>
		</div>
		} @if (typeIcon(); as typeIcon) {
		<div libFlexColumn>
			<lib-icon [type]="typeIcon"></lib-icon>
		</div>
		}
		<div libFlexColumn libFlexFill>
			{{ title() }}
		</div>
		@if (subtitle(); as subtitle) {
		<div libFlexColumn class="ui-tooltip-subtitle">{{ subtitle }}</div>
		} @if (disabled() === true) {
		<div libFlexColumn>
			<lib-icon [type]="'disabled'"></lib-icon>
		</div>
		} @if (avatarLocation() === 'end' && avatar(); as avatar) {
		<div libFlexColumn>
			<lib-image
				[imageSize]="'50px'"
				[maxHeight]="30"
				[maxWidth]="30"
				[image]="avatar"
				[alt]="'Avatar image'"
			></lib-image>
		</div>
		}
	</div>
	} @if (mode() === 'custom') {
	<ng-content></ng-content>
	}
</ng-template>

<lib-link [routerLink]="routerLink()" (click)="handleClick($event)" [linkStyle]="'noUnderline'">
	<div
		class="ui-tooltip-menu-item-wrapper"
		[class.no-padding]="removePadding()"
		[class.first]="isFirst()"
		[class.last]="isLast()"
	>
		<div
			class="ui-tooltip-menu-item"
			[class.no-border]="removeBorder()"
			[class.with-border]="!removeBorder()"
			[class.default]="calculatedDesign() === 'default'"
			[class.delete]="calculatedDesign() === 'delete'"
			[class.disabled]="calculatedDesign() === 'disabled'"
		>
			<ng-template [ngTemplateOutlet]="itemTemplate"></ng-template>
		</div>
	</div>
</lib-link>
